import { createContext, use } from 'react';
import { defaultBrandConfig, type BrandConfig as BrandSettings } from '@lds-efsp/brand-config';
import { deploymentConfig } from '../../config/deployment';

// The portal's brand settings are the active brand pack from
// @lds-efsp/brand-config — the one place a brand's name, colors, type, logos
// and wording are written. Which pack is active is a deployment setting (the
// `brand` key of /config.js, from the container's BRAND env var).
//
// The support address is deployment identity, not brand copy, so it comes from
// config/deployment.ts, which also honors the build-time tier.
//
// footerLinks is restated on purpose. The footer's legal links are pinned in
// BOTH files by legal-link-sites.test.tsx, the eslint rule scoped to this file
// and the SPEC-SOR-232-v3 shards, so neither copy can drift back to a "#".
export const BrandConfig: BrandSettings = {
  ...defaultBrandConfig,
  contact: { ...defaultBrandConfig.contact, email: deploymentConfig.supportEmail },
  footerLinks: {
    accessibility: { label: "Accessibility", url: "/legal/accessibility" },
    privacy: { label: "Privacy Policy", url: "/legal/privacy" },
    terms: { label: "Terms of Service", url: "/legal/terms" },
  },
};

export type BrandConfigData = BrandSettings;

export const BrandContext = createContext(BrandConfig);
export const useBrand = () => use(BrandContext);
